import React, { FC, memo, useCallback } from "react";
import { Icon, IconToggle } from "@evergis/ui";
import { useTranslation } from "react-i18next";
import { getNextSortType } from "./getNextSortType";

import { SortOrder } from "./types";

interface SortByAliasProps {
  active: boolean;
  order: SortOrder;
  setSort: (sort: string) => void;
}

export const SortByAlias: FC<SortByAliasProps> = memo(({ active, order, setSort }) => {
  const { t } = useTranslation("catalog");
  const handleSort = useCallback(() => setSort(getNextSortType(order)), [order, setSort]);

  return (
    <IconToggle isSelected={active} onClick={handleSort} title={t("sortByName")}>
      {order === SortOrder.DES ? <Icon kind="alphabet_sort_za" /> : <Icon kind="alphabet_sort_az" />}
    </IconToggle>
  );
});
